import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { AlertWarningCircleIcon, CloseCircleIcon } from '@calendly/ui/components/icons'
import { colorIconDestructive, colorTextSecondary } from '@calendly/ui/theme'

import { VIEWS } from './constants'

export const getUsersIntegrationsBreakdown = ({ data, isFetching, isError }) => {
  if (!isFetching && !isError) {
    const users = data?.breakdown || []

    return { users, isFetching }
  }

  return { users: [], isFetching }
}

export const getSwitcherOptions = ({ notConnectedCount, errorCount, view }) => ([
  {
    icon: <CloseCircleIcon color={view === VIEWS.notConnected ? colorIconDestructive : colorTextSecondary} />,
    text: I18n.t('publisher.admin.dashboard.section.users.modal.view.not_connected', { count: notConnectedCount }),
    value: VIEWS.notConnected
  },
  {
    icon: <AlertWarningCircleIcon color={view === VIEWS.hasErrors ? colorIconDestructive : colorTextSecondary} />,
    text: I18n.t('publisher.admin.dashboard.section.users.modal.view.error', { count: errorCount }),
    value: VIEWS.hasErrors
  }
])

export const getIntegrationNames = (integrations) => (
  integrations.map((integration) => {
    switch (integration) {
      case ('webex'):
        return I18n.t('publisher.integrations.names.webex')
      case ('gotomeeting'):
        return I18n.t('publisher.integrations.names.gotomeeting')
      case ('gmail'):
        return I18n.t('publisher.integrations.names.google_meet')
      case ('ms_teams'):
        return I18n.t('publisher.integrations.names.microsoft_teams')
      case ('zoom_account'):
        return I18n.t('publisher.integrations.names.zoom')
      case ('google'):
        return I18n.t('publisher.integrations.names.google_calendar')
      case ('outlook'):
        return I18n.t('publisher.integrations.names.office_365_outlook')
      case ('outlook_desktop'):
        return I18n.t('publisher.integrations.names.outlook_calendar')
      case ('icloud'):
        return I18n.t('publisher.integrations.names.icloud_calendar')
      case ('exchange'):
        return I18n.t('publisher.integrations.names.exchange_calendar')
      default:
        return undefined
    }
  })
)

export const userToMembership = ({ uuid, name, email, avatarUrl, avatarLetter }) => ({
  user_uuid: uuid,
  name,
  email,
  avatar_url: avatarUrl,
  avatar_letter: avatarLetter
})

export const invitationToMembership = ({ uuid, email, avatar_letter: avatarLetter, status }) => ({
  user_uuid: uuid,
  email,
  avatar_letter: avatarLetter,
  status
})

export const getTileTitle = ({ tileType, count }) => (
  count > 0
    ? HtmlParser(I18n.t(`publisher.admin.dashboard.section.users.card.${tileType}.title`, { count }))
    : I18n.t(`publisher.admin.dashboard.section.users.card.${tileType}.empty_state`)
)
